import { render, staticRenderFns } from "./ServicesCards.vue?vue&type=template&id=c3665fd2&scoped=true"
import script from "./ServicesCards.vue?vue&type=script&lang=js"
export * from "./ServicesCards.vue?vue&type=script&lang=js"
import style0 from "./ServicesCards.vue?vue&type=style&index=0&id=c3665fd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3665fd2",
  null
  
)

export default component.exports